import { workstationTurn } from "../../helpers/fetching";

export default {
  state: {
    turn: {},
    loading: false,
    error: null,
  },
  mutations: {
    clearError(state) {
      state.error = null;
    },
    setError(state, data) {
      state.error = data;
      state.loading = false;
    },
    setLoadingTurn(state, data) {
      state.loading = data;
      state.error = null;
    },
    setTurn(state, data) {
      state.turn = data;
      state.loading = false;
      state.error = null;
    },
  },
  actions: {
    getWorkstationTurn({ commit }, id) {
      if (!id) return;
      commit("clearError");
      commit("setLoadingTurn", true);
      workstationTurn(id)
        .then((response) => {
          commit("setTurn", response);
          commit("setLoadingTurn", false);
        })
        .catch((error) => {
          commit("setError", error);
        });
    },
  },
};
